// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__2UL3C","dragIcon":"Choice_dragIcon__fwMUn","left":"Choice_left__AM8pU","input":"Choice_input__37V24"};